module.exports = __webpack_public_path__ + "img/icon_status_green_fill_small.4c9c9456.svg";